import React, { CSSProperties, memo } from 'react';
import { Styled } from '../../types';
import FeatherIcon from './FeatherIcon';
import FontAwesomeIcon from './FontAwesomeIcon';
import IonIcon from './IonIcon';

export type IconType = 'feather' | 'fa' | 'ion';

export type IconProps = CSSProperties &
  Styled & {
    type: IconType;
    name: string;
    size?: number;
  };

const Icon = ({ type, ...restProps }: IconProps) => {
  if (type === 'feather') {
    return <FeatherIcon {...restProps} />;
  }
  if (type === 'fa') {
    return <FontAwesomeIcon {...restProps} />;
  }
  if (type === 'ion') {
    return <IonIcon {...restProps} />;
  }
  return null;
};

export default memo(Icon);
